import React from "react"
import { Modal, ModalFooter } from "react-bootstrap"

const IN_COMPLIANCE = 'in_compliance'
const OUT_OF_COMPLIANCE = 'out_of_compliance'

export const ComplianceCheckModal = ({show, setShow, modalData}) => {

  if(!modalData)
    return null

  const getComplianceMessage = () => {
    if(!modalData.complianceChecked) {
      return(
        <div>
          {window.I18n.t('courses.whs_complance_popup.whs_check_failed')}
        </div>
      )
    }

    const compliance = window.I18n.t(`courses.whs_complance_popup.${modalData.inCompliance ? IN_COMPLIANCE : OUT_OF_COMPLIANCE}`)

    return(
      <div>
        {window.I18n.t('courses.whs_complance_popup.whs_check_no_html', {course_name: modalData.name})}
        <b>{compliance}</b>
        <br/>
        {!modalData.inCompliance && window.I18n.t('courses.whs_complance_popup.please_reimport_course')}
      </div>
    )
  }

  return (
    <Modal show={show} onHide={() => setShow(false)} className="center-modal" backdrop={false}>
      <div className="courses-modal-title-container">
        <div className="courses-modal-title">
          {window.I18n.t('courses.whs_complance_popup.whs_complance_check')}
        </div>
      </div>
      <Modal.Body className='add-margin-bottom-10 add-margin-top-10 courses-small-modal-body-container'>
        <div  className="btsp_notices"> 
          {
            getComplianceMessage()
          }
        </div>
      </Modal.Body>
      <ModalFooter>
        <div className="courses-modal-buttons-container">
          <button onClick={() => setShow(false)} className="cancel_action small grey button btsp_small_white_button">Close</button>
        </div>
      </ModalFooter>
    </Modal>
  )
}